'use client'

import { useProductFavoriteStatus } from '@/feature/product/hooks/useProductFavoriteStatus'
import type { ProductType } from '@gql-generated/graphql'
import { ActionButtons } from '@/feature/product/components/product-actions/ActionButtons.client'

export function ProductDetailsActionButtons({
  reference,
  name,
  type,
}: {
  reference: string
  name: string
  type: ProductType
}) {
  const { data: isFavorite } = useProductFavoriteStatus(reference)

  return (
    <ActionButtons
      productType={type}
      productReference={reference}
      productName={name ?? ''}
      isFavorite={isFavorite}
    />
  )
}
